/**
 * CONTACT-MGMT (CM-5/CM-6) — TanStack Query keys for the contacts feature.
 */
import type { ContactsListParams } from "./types.js";

export const contactsKeys = {
  all: ["contacts"] as const,
  lists: () => [...contactsKeys.all, "list"] as const,
  list: (params: ContactsListParams) =>
    [...contactsKeys.lists(), params] as const,
  /** Debounced dedupe-warn typeahead on the Add form (CM-D8). */
  dedupe: (q: string) => [...contactsKeys.all, "dedupe", q] as const,
  details: () => [...contactsKeys.all, "detail"] as const,
  detail: (id: string) => [...contactsKeys.details(), id] as const,
  usage: (id: string) => [...contactsKeys.all, "usage", id] as const,
};
